(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-rail-controls"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('pdp-product-rail')){
  customElements.define('pdp-product-rail',class extends HTMLElement{
    connectedCallback(){
      this.controller=new AbortController();
      const signal=this.controller.signal;
      this.rail=this.querySelector('.product-rail');
      const prev=this.querySelector('[data-pdp-prev]'),next=this.querySelector('[data-pdp-next]');
      if(!this.rail||!prev||!next)return;
      const sync=()=>{const max=this.rail.scrollWidth-this.rail.clientWidth;prev.disabled=this.rail.scrollLeft<2;next.disabled=max<2||this.rail.scrollLeft>=max-2;};
      const move=dir=>this.rail.scrollBy({left:dir*this.rail.clientWidth*.9,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
      prev.addEventListener('click',()=>move(-1),{signal});next.addEventListener('click',()=>move(1),{signal});
      this.rail.addEventListener('scroll',sync,{passive:true,signal});
      this.rail.addEventListener('keydown',event=>{if(event.target!==this.rail)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}},{signal});
      this.observer=new ResizeObserver(sync);this.observer.observe(this.rail);
      this.mutations=new MutationObserver(sync);this.mutations.observe(this.rail,{childList:true});sync();
    }
    disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();this.mutations?.disconnect();}
  });
}
  } catch(e) { console.error(e); }
})();

})();
